import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IRecurrencyAttempt } from 'app/interfaces/recurrent-attempts.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
@Component({
	selector: 'calendar-slot-recurency-attempt',
	templateUrl: './calendar-slot-recurency-attempt.component.html',
	styleUrls: ['./calendar-slot-recurency-attempt.component.scss'],
})
export class CalendarSlotRecurrencyAttemptComponent implements OnInit {
	@Input() recurrencyAttempt: IRecurrencyAttempt;
	@Output() onOpenDetails = new EventEmitter();
	_recurrencyAttempt;
	isRecurrenctModalOpen = false;

	constructor(public atService: ActionTrackerService) {}

	ngOnInit(): void {
		this._recurrencyAttempt = {
			...this.recurrencyAttempt,
			formatedHours: `${this.recurrencyAttempt.luxonStartDate.toFormat(
				'HH:mm'
			)} - ${this.recurrencyAttempt.luxonEndDate.toFormat('HH:mm')}`,
		};
	}

	trackOpen() {
		this.atService.eventTracker(
			SCOPE_TYPE.Caledar,
			SUBSCOPE_TYPE.RecurrencyAttempt,
			ITEM_TYPE.Card,
			INTERACTION_TYPE.Click,
			{}
		);
	}
}
